import { useEffect, useRef, memo } from "react";

const AdsterraNativeBanner = memo(() => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Check if script has already been appended
    const existing = containerRef.current.querySelector("script");
    if (!existing) {
      const script = document.createElement("script");
      script.async = true;
      script.setAttribute("data-cfasync", "false");
      script.src = "https://pl31202960.profitableratecpmnetwork.com/b1e0b9b02eff12b3bed98dd41a14b94e/invoke.js";
      containerRef.current.appendChild(script);
    }
  }, []);

  return (
    <div className="w-full my-4 flex flex-col items-center justify-center px-4">
      <div
        id="container-b1e0b9b02eff12b3bed98dd41a14b94e"
        ref={containerRef}
        className="w-full max-w-5xl flex justify-center items-center"
      />
    </div>
  );
});

export default AdsterraNativeBanner;
